import { React, useEffect, useState, useRef } from 'react';
import { Link, Outlet, Route, useNavigate } from 'react-router-dom';
import ROUTES from '../../nav/Routes';

const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth' // you can use 'auto' for instant scroll
    });
};

// Import the necessary modules from swiper
// import { Autoplay, Pagination } from 'swiper';

function Career() {
    return (

        <>
            <div class="main bg-80">
                <div id="hero" class="Starter section dark-background">

                    <img src="assets/img/image11.jpg" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" data-aos="fade-in" />
                    <div class="container ">
                        <div class="row justify-content-center text-center" data-aos="fade-up" data-aos-delay="100">
                            <div class="col-xl-6 col-lg-8">
                                <h2>Build Your Future With Us<span>.</span></h2>
                                <p>Join a team that's redefining logistics with innovation, dedication, and growth opportunities at every turn.</p>
                            </div>
                        </div>

                    </div>
                </div>


                <div class="container rc-hero-section d-flex justify-content-between flex-wrap-reverse">
                    <div class="col-lg-6 rc-image-wrapper">
                        <img src="assets/img/image12.jpg" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" />
                        <div class="rc-circle-overlay"></div>
                    </div>
                    <div class="col-lg-6">
                        <h1 class="rc-title">
                            Start Your Dream Job <br />
                            At <span class="rc-highlight">Mann Carriers</span>
                        </h1>
                        <p class="rc-text mt-4">
                            Ready to embark on a rewarding journey with us? Explore our current job openings below and take the next step toward a fulfilling career in transportation. We look forward to welcoming you aboard!
                        </p>
                        <a href="#career1" class="rc-btn-outline mt-4">Explore Jobs</a>
                    </div>
                </div>
            </div>


            <div className="bg-offwhite  py-5" id="career1">
            <div className="container my-5  " >
                <div className="text-center mb-5">
                    <h4 className="">We Are Hiring</h4>
                    <h1 className="display-6 fw-bolder mb-3">We Need Experienced Staff At</h1>
                    <h3 className="display-7 fw-bolder mb-3 text-warning">Mann Carriers LLC</h3>
                </div>
                <div className="row g-4">
                    <div className="col-md-6">
                        <div className="career-card h-100">
                            <div className="career-img">
                                <img src="assets/img/image22.jpg" className="img-fluid" alt="Truck Driver" />
                            </div>
                            <div className="career-body p-4">
                                <h3 className="fw-bold text-darklight mb-3">Truck Driver</h3>
                                <p className="career-text">
                                    Mann Carriers LLC is hiring experienced truck drivers to join our growing fleet. The ideal candidate will have a proven track record of safe driving, route familiarity, and a strong sense of responsibility. You'll ensure timely deliveries, maintain vehicle condition, and represent our company with professionalism.
                                </p>
                                <Link to={ROUTES.applydispatcher.name} className="career-btn mt-3" onClick={scrollToTop}>Apply Now</Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="career-card h-100">
                            <div className="career-img">
                                <img src="assets/img/image24.jpg" className="img-fluid" alt="Dispatcher" />
                            </div>
                            <div className="career-body p-4">
                                <h3 className="fw-bold text-darklight mb-3">Dispatcher</h3>
                                <p className="career-text">
                                    We're also looking for an experienced Dispatcher to manage day-to-day logistics. Responsibilities include route planning, coordinating with drivers, ensuring timely pickups and deliveries, and handling communication with clients. If you're organized and thrive under pressure, we want to hear from you.
                                </p>
                                <Link to={ROUTES.applydispatcher.name} className="career-btn mt-3" onClick={scrollToTop}>Apply Now</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>


            <section class="rc-reasons-section py-5 ">
                <div class="container my-5 py-5">
                    <div class="text-center mb-5">
                        <div class="rc-subtitle1 mb-2">Why Choose Mann Carriers?</div>
                        <h2 class="rc-title1 mb-3">6 Reasons To Start Your Career With Mann Carriers</h2>
                        <p class="rc-desc">
                            Join one of the most trusted names in logistics. At Mann Carriers, we value our drivers and logistics professionals, offering stability, respect, and real career growth on the road.
                        </p>
                    </div>
                    <div class="row g-4">
                        <div class="col-md-6 col-lg-4">
                            <div class="rc-card">
                                <div class="rc-icon"><i class="bi bi-shield-check"></i></div>
                                <h5 class="rc-card-title">Reliable Employment</h5>
                                <p class="rc-card-text">
                                    We offer dependable, long-term employment in a constantly moving industry with year-round demand.
                                </p>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4">
                            <div class="rc-card">
                                <div class="rc-icon"><i class="bi bi-currency-dollar"></i></div>
                                <h5 class="rc-card-title">Attractive Pay Packages</h5>
                                <p class="rc-card-text">
                                    Get paid what you deserve — with competitive salaries, bonuses, and timely payments.
                                </p>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4">
                            <div class="rc-card">
                                <div class="rc-icon"><i class="bi bi-bar-chart-line"></i></div>
                                <h5 class="rc-card-title">Career Advancement</h5>
                                <p class="rc-card-text">
                                    Opportunities to grow from driver to manager with training, upskilling, and leadership roles.
                                </p>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4">
                            <div class="rc-card">
                                <div class="rc-icon"><i class="bi bi-truck"></i></div>
                                <h5 class="rc-card-title">Modern Fleet</h5>
                                <p class="rc-card-text">
                                    Drive with confidence in our well-maintained, GPS-equipped trucks designed for safety and efficiency.
                                </p>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4">
                            <div class="rc-card">
                                <div class="rc-icon"><i class="bi bi-people"></i></div>
                                <h5 class="rc-card-title">Respectful Work Culture</h5>
                                <p class="rc-card-text">
                                    Join a team that treats every driver and staff member like family, not just an employee ID.
                                </p>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4">
                            <div class="rc-card">
                                <div class="rc-icon"><i class="bi bi-house-heart"></i></div>
                                <h5 class="rc-card-title">Work-Life Harmony</h5>
                                <p class="rc-card-text">
                                    Routes and schedules designed to give you the rest and home time you deserve.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}
export default Career;